(function () {
    'use strict';

    const DEBUG = false; // Set to false to disable logging
    const log = (...args) => {
        if (DEBUG) {
            console.log('[MM Header Secondary Nav]', ...args);
        }
    };
    const warn = (...args) => {
        if (DEBUG) {
            console.warn('[MM Header Secondary Nav]', ...args);
        }
    };
    const error = (...args) => {
        console.error('[MM Header Secondary Nav]', ...args);
    };

    log('Script initialized');

    // Tailwind "component" style for pills (kept in JS so the demo stays single-file)
    // You can move these classes into your theme styles easily.
    const navPills = document.querySelectorAll('.nav-pill');
    log(`Found ${navPills.length} nav-pill elements`);

    navPills.forEach((a, index) => {
        a.className =
            'nav-pill tw-shrink-0 tw-text-white tw-no-underline tw-px-4 tw-py-2 tw-transition ' +
            'hover:tw-underline';
        log(`Applied classes to nav-pill ${index + 1}:`, a.className);
    });

    // Overflow nav controller
    const overflowNavs = document.querySelectorAll('[data-overflow-nav]');
    log(`Found ${overflowNavs.length} overflow nav wrapper(s)`);

    if (overflowNavs.length === 0) {
        error('No [data-overflow-nav] element found!');
        return;
    }

    overflowNavs.forEach((wrapper, wrapperIndex) => {
        log(`\n=== Processing wrapper ${wrapperIndex + 1} ===`);

        const scrollEl = wrapper.querySelector('[data-nav-scroll]');
        const prevBtn = wrapper.querySelector('[data-nav-prev]');
        const nextBtn = wrapper.querySelector('[data-nav-next]');
        const fadeLeft = wrapper.querySelector('[data-nav-fade-left]');
        const fadeRight = wrapper.querySelector('[data-nav-fade-right]');

        log('Elements found:', {
            scrollEl: !!scrollEl,
            prevBtn: !!prevBtn,
            nextBtn: !!nextBtn,
            fadeLeft: !!fadeLeft,
            fadeRight: !!fadeRight,
        });

        if (!scrollEl) {
            error('Missing [data-nav-scroll] element');
            return;
        }
        if (!prevBtn) {
            error('Missing [data-nav-prev] element');
            return;
        }
        if (!nextBtn) {
            error('Missing [data-nav-next] element');
            return;
        }
        if (!fadeLeft) {
            error('Missing [data-nav-fade-left] element');
            return;
        }
        if (!fadeRight) {
            error('Missing [data-nav-fade-right] element');
            return;
        }

        log('All required elements found, initializing controller...');

        const updateState = () => {
            // Force a reflow to ensure accurate measurements
            void scrollEl.offsetWidth;

            const scrollWidth = scrollEl.scrollWidth;
            const clientWidth = scrollEl.clientWidth;
            const scrollLeft = scrollEl.scrollLeft;
            const maxScroll = scrollWidth - clientWidth;
            const canScrollLeft = scrollLeft > 1;
            const canScrollRight = scrollLeft < maxScroll - 1;

            // Get parent container dimensions
            const parentEl = scrollEl.parentElement;
            const wrapperEl = wrapper;

            log('updateState:', {
                scrollLeft,
                scrollWidth,
                clientWidth,
                maxScroll,
                canScrollLeft,
                canScrollRight,
                hasOverflow: scrollWidth > clientWidth,
                parentWidth: parentEl ? parentEl.clientWidth : null,
                wrapperWidth: wrapperEl ? wrapperEl.clientWidth : null,
                computedStyles: {
                    nav: {
                        width: window.getComputedStyle(scrollEl).width,
                        maxWidth: window.getComputedStyle(scrollEl).maxWidth,
                        minWidth: window.getComputedStyle(scrollEl).minWidth,
                        overflowX: window.getComputedStyle(scrollEl).overflowX,
                        boxSizing: window.getComputedStyle(scrollEl).boxSizing,
                    },
                    wrapper: wrapperEl
                        ? {
                                width: window.getComputedStyle(wrapperEl).width,
                                maxWidth: window.getComputedStyle(wrapperEl).maxWidth,
                                minWidth: window.getComputedStyle(wrapperEl).minWidth,
                            }
                        : null,
                },
            });

            prevBtn.classList.toggle('tw-hidden', !canScrollLeft);
            prevBtn.classList.toggle('tw-flex', canScrollLeft);
            fadeLeft.classList.toggle('tw-hidden', !canScrollLeft);

            nextBtn.classList.toggle('tw-hidden', !canScrollRight);
            nextBtn.classList.toggle('tw-flex', canScrollRight);
            fadeRight.classList.toggle('tw-hidden', !canScrollRight);
        };

        const scrollByAmount = direction => {
            const amount = direction * scrollEl.clientWidth * 0.8;
            log(`Scrolling ${direction > 0 ? 'right' : 'left'} by ${amount}px`);
            scrollEl.scrollBy({
                left: amount,
                behavior: 'smooth',
            });
        };

        prevBtn.addEventListener('click', () => {
            log('Previous button clicked');
            scrollByAmount(-1);
        });
        nextBtn.addEventListener('click', () => {
            log('Next button clicked');
            scrollByAmount(1);
        });

        scrollEl.addEventListener('scroll', () => {
            log('Scroll event fired');
            updateState();
        });

        // Wheel -> horizontal (nice for desktop)
        scrollEl.addEventListener(
            'wheel',
            e => {
                if (Math.abs(e.deltaX) < Math.abs(e.deltaY)) {
                    log('Converting vertical wheel to horizontal scroll', {
                        deltaX: e.deltaX,
                        deltaY: e.deltaY,
                    });
                    e.preventDefault();
                    scrollEl.scrollLeft += e.deltaY;
                }
            },
            { passive: false }
        );

        // Keep active pill visible + set active class
        scrollEl.addEventListener('click', e => {
            const link = e.target.closest('a');
            if (!link) {
                log('Click event on non-link element');
                return;
            }

            log('Link clicked:', link.href, link.textContent.trim());

            // Ensure clicked item stays nicely in view
            link.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });

        const resizeObserver = new ResizeObserver(() => {
            log('ResizeObserver triggered');
            updateState();
        });
        resizeObserver.observe(scrollEl);
        log('ResizeObserver attached to scroll element');

        // Initial state update
        log('Running initial updateState()');
        updateState();

        // Demo buttons (if they exist)
        const scrollToEndBtn = document.getElementById('scrollToEnd');
        const scrollToStartBtn = document.getElementById('scrollToStart');

        if (scrollToEndBtn) {
            scrollToEndBtn.addEventListener('click', () => {
                log('Scroll to end button clicked');
                scrollEl.scrollTo({ left: scrollEl.scrollWidth, behavior: 'smooth' });
            });
        }
        if (scrollToStartBtn) {
            scrollToStartBtn.addEventListener('click', () => {
                log('Scroll to start button clicked');
                scrollEl.scrollTo({ left: 0, behavior: 'smooth' });
            });
        }

        log(`Wrapper ${wrapperIndex + 1} initialization complete\n`);
    });

    log('All wrappers processed');
})();